import request from "@/untils/request.js";
//获取热门直播
export function getHomeData(query) {
  return request({
    url: "/live/page",
    method: "get",
    params: query,
  });
}
///获取推荐赛事列表 (type 0-全部 1-足球 2-篮球)
export function homeMatchRecList(type) {
  return request({
    url: "/match/list?type=" + type,
    method: "get",
  });
}
//获取app基础配置信息
export function getInit() {
  return request({
    url: "/member/config/init",
    method: "get",
  });
}
//获取首页轮播广告
export function getAdsList() {
  return request({
    url: "/live/ads/getHomeAdList",
    method: "get",
  });
}
